import _classCallCheck from "/Users/jhonsem/Work/FaceAnalysis_Web/node_modules/@babel/runtime-corejs2/helpers/esm/classCallCheck";
import _createClass from "/Users/jhonsem/Work/FaceAnalysis_Web/node_modules/@babel/runtime-corejs2/helpers/esm/createClass";
import _possibleConstructorReturn from "/Users/jhonsem/Work/FaceAnalysis_Web/node_modules/@babel/runtime-corejs2/helpers/esm/possibleConstructorReturn";
import _getPrototypeOf from "/Users/jhonsem/Work/FaceAnalysis_Web/node_modules/@babel/runtime-corejs2/helpers/esm/getPrototypeOf";
import _inherits from "/Users/jhonsem/Work/FaceAnalysis_Web/node_modules/@babel/runtime-corejs2/helpers/esm/inherits";
import * as tslib_1 from "tslib";
import { Component, Vue } from "vue-property-decorator";
import { Getter } from "vuex-class";
import * as types from "@/store/constants/types";
import fateSpec from "./fateSpec.vue";
import slecteFate from "./slecteFate.vue";
import ShortFateCraouser from "./shortFateCraouser.vue";
import { getLang } from '@/api/utils/apiHelper';

var RevealFate =
/*#__PURE__*/
function (_Vue) {
  _inherits(RevealFate, _Vue);

  function RevealFate() {
    _classCallCheck(this, RevealFate);

    return _possibleConstructorReturn(this, _getPrototypeOf(RevealFate).apply(this, arguments));
  }

  _createClass(RevealFate, [{
    key: "isGerman",
    get: function get() {
      return getLang() === "de";
    }
  }, {
    key: "isShow",
    get: function get() {
      return this.horoscope;
    }
  }]);

  return RevealFate;
}(Vue);

tslib_1.__decorate([Getter(types.GETTER_HOROSCOPE)], RevealFate.prototype, "horoscope", void 0);

RevealFate = tslib_1.__decorate([Component({
  components: {
    fateSpec: fateSpec,
    slecteFate: slecteFate,
    ShortFateCraouser: ShortFateCraouser
  }
})], RevealFate);
export default RevealFate;